import React from 'react';
import clsx from 'clsx';
import {ProgressCircle} from '@ui/progress/progress-circle';
import {useTrans} from '@ui/i18n/use-trans';

interface FullPageLoaderProps {
  className?: string;
  screen?: boolean;
}
export function FullPageLoader({className, screen}: FullPageLoaderProps) {
  const {trans} = useTrans();
  return (
    <div
      className={clsx(
        'flex flex-auto items-center justify-center',
        screen ? 'h-screen w-screen' : 'h-full w-full',
        className,
      )}
    >
      <ProgressCircle
        isIndeterminate
        aria-label={trans({message: 'Loading page...'})}
        size="md"
      />
    </div>
  );
}
